export enum RootIndexActionTypes {
  NON_ACTION = 'NON_ACTION',
}
